import React from "react";
import { useLocation } from "react-router-dom";
import Seo, { DEFAULT_IMAGE } from "./Seo";
import { ROUTES, NOINDEX_PREFIXES } from "../seo/seoData";

/**
 * SEO centralisé par route.
 *
 * Monté une seule fois dans l'application, ce composant détermine les balises
 * SEO (title, description, keywords, canonical, Open Graph, JSON-LD) à partir
 * de l'URL courante. Il n'affiche rien et ne modifie ni le design ni les
 * fonctionnalités : il n'écrit que dans le <head>.
 *
 * La table route -> SEO vit dans src/seo/seoData.js (source unique partagée
 * avec le générateur de pré-rendu statique scripts/prerender-seo.cjs), de sorte
 * que le SEO rendu en JavaScript et celui injecté dans le HTML statique restent
 * toujours identiques. Les pages dynamiques (/sejour/:id, /circuit/:id) gèrent
 * leur propre SEO directement dans leur composant.
 */

export default function RouteSeo() {
  const { pathname } = useLocation();

  // Correspondance exacte
  if (ROUTES[pathname]) {
    return <Seo path={pathname} image={DEFAULT_IMAGE} {...ROUTES[pathname]} />;
  }

  // Pages privées / techniques
  if (NOINDEX_PREFIXES.some((p) => pathname === p || pathname.startsWith(`${p}/`))) {
    return <Seo path={pathname} noindex title="Espace privé" />;
  }

  // Détail séjour (/sejour/:id)
  if (pathname.startsWith("/sejour/")) {
    return (
      <Seo
        path={pathname}
        title="Séjour de luxe au Maroc"
        description="Découvrez ce séjour d'exception au Maroc avec Nouzha : hébergement haut de gamme, confort premium et service sur mesure. Réservez dès maintenant."
        keywords="séjour Maroc, hôtel luxe Maroc, riad Maroc, réservation séjour Maroc"
        type="article"
      />
    );
  }

  // Détail circuit (/circuit/:id)
  if (pathname.startsWith("/circuit/")) {
    return (
      <Seo
        path={pathname}
        title="Circuit d'exception au Maroc"
        description="Découvrez ce circuit au Maroc avec Nouzha : itinéraire d'exception, guide expert et transport privé. Vivez un voyage inoubliable au Maroc."
        keywords="circuit Maroc, voyage organisé Maroc, circuit désert Maroc, circuit privé Maroc"
        type="article"
      />
    );
  }

  // Fallback : métadonnées de marque par défaut
  return <Seo path={pathname} />;
}
